import React from "react"
import { match } from "ts-pattern"

import Tick from "~/common/react-icons/tick"
import Cross from "~/common/react-icons/cross"
import { ScoreLevelObject } from "~/SmartMatching/helpers"
import styles from "./MatchSectionDetail.module.css"
import { Comparison, SmartMatch } from "~/common/react-icons"

type Props = {
  scoreLevel: ScoreLevelObject
  title?: string
  targetDetail: string
  sourceDetail: string
}

const DetailContainer = ({
  scoreLevel,
  title,
  children,
  detail,
  noIconBackground,
}: {
  scoreLevel: ScoreLevelObject
  title?: string
  detail?: string
  children: React.ReactNode
  noIconBackground?: boolean
}) => {
  const iconColor = !!scoreLevel ? scoreLevel.color : "var(--alert)"
  const backgroundColor = !!scoreLevel ? scoreLevel.backgroundColor : "#FFF0F0"
  const scoreValue = scoreLevel?.value

  return (
    <div className={styles.detailContainer} style={{ backgroundColor }}>
      <div className={styles.headingContainer}>
        <div
          className={styles.iconContainer}
          style={{
            backgroundColor: noIconBackground ? "transparent" : iconColor,
          }}
        >
          {children}
        </div>
        <div className={styles.title}>{title}</div>
      </div>
      {scoreValue !== "exact" && (
        <div className={styles.subtitle}>{detail}</div>
      )}
    </div>
  )
}

const MatchSectionDetail = ({
  scoreLevel,
  targetDetail,
  sourceDetail,
}: Props) => {
  if (!scoreLevel) {
    return (
      <DetailContainer
        scoreLevel={scoreLevel}
        title={sourceDetail}
        detail={targetDetail}
      >
        <Cross size={10} color="white" />
      </DetailContainer>
    )
  }

  return match(scoreLevel.value)
    .with("exact", () => (
      <DetailContainer
        scoreLevel={scoreLevel}
        title={sourceDetail}
        detail={targetDetail}
      >
        <Tick color="white" />
      </DetailContainer>
    ))
    .with("great", () => (
      <DetailContainer
        scoreLevel={scoreLevel}
        title={sourceDetail}
        detail={targetDetail}
        noIconBackground
      >
        <Comparison color={scoreLevel.color} />
      </DetailContainer>
    ))
    .with("good", () => (
      <DetailContainer
        scoreLevel={scoreLevel}
        title={sourceDetail}
        detail={targetDetail}
        noIconBackground
      >
        <Comparison color={scoreLevel.color} />
      </DetailContainer>
    ))
    .with("fair", () => (
      <DetailContainer
        scoreLevel={scoreLevel}
        title={sourceDetail}
        detail={targetDetail}
        noIconBackground
      >
        <Comparison color={scoreLevel.color} />
      </DetailContainer>
    ))
    .with("limited", () => (
      <DetailContainer
        scoreLevel={scoreLevel}
        title={sourceDetail}
        detail={targetDetail}
      >
        <SmartMatch color="white" />
      </DetailContainer>
    ))
    .exhaustive()
}

export default MatchSectionDetail
